import React, { useContext, useEffect, useState } from 'react'
import { Context } from '../Context/Context';
import { Flip, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { BetDataJantri } from '../Api/BetDataJantri';
import { BetPlace } from '../Api/BetPlace';

// import UpdateResult from '../component/UpdateResult';

export default function Number() {

    const navigate = useNavigate();
    const { sessionDetail, setWallet, setLoad, setLoadColor } = useContext(Context);
    const auth_token = JSON.parse(localStorage.getItem('userinfo'))?.auth_token;
    const [numberData, setNumberData] = useState([])
    const [harufAndar, setHarufAndar] = useState([])
    const [harufBahar, setHarufBahar] = useState([]);
    const [isClient, setIsClient] = useState(null);
    const [isGames, setIsGames] = useState(null);
    const [hrufType, setHrufType] = useState('andar');
    const [hrufNumber, setHrufNumber] = useState(null);
    const [hrufAmount, setHrufAmount] = useState(0);
    const [crossingJodaCut, setCrossingJodaCut] = useState(false);
    const [crossingNumber, setCrossingNumber] = useState(null);
    const [crossingAmount, setCrossingAmount] = useState(0);
    const [battacrossingNumber1, setBattaCrossingNumber1] = useState(null);
    const [battacrossingNumber2, setBattaCrossingNumber2] = useState(null);
    const [battacrossingAmount, setBattaCrossingAmount] = useState(0);
    const [ladiNumber1, setLadiNumber1] = useState(null);
    const [ladiNumber2, setLadiNumber2] = useState(null);
    const [ladiAmount, setLadiAmount] = useState(0);
    const [stringData, setStringData] = useState("");
    const [isPalat, setIsPalat] = useState(false);
    const [placeholder, setPlaceholder] = useState("Paste text here...");
    const [showFooter, setShowFooter] = useState(false);


    const clearData = () => {
        console.log("clearData called --> ");
        setHrufNumber(null);
        setHrufAmount(0);
        setStringData('');
        setCrossingNumber(null);
        setCrossingAmount(0);
        setCrossingJodaCut(false);
        setBattaCrossingNumber1(null);
        setBattaCrossingNumber2(null);
        setBattaCrossingAmount(0);
        setLadiNumber1(null);
        setLadiNumber2(null);
        setLadiAmount(0);
        setIsPalat(false);

    }


    useEffect(() => {
        if (auth_token && Object.keys(sessionDetail).length > 0) {
            setNumberData(sessionDetail?.bet_numbers)

        }
    }, [sessionDetail, auth_token]);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowFooter(true);
        }, 5000); // Delay in milliseconds

        return () => clearTimeout(timer); // Cleanup
    }, []);

    useEffect(() => {
        // Function to check if the user has scrolled near the bottom
        const handleScroll = () => {
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 800) {
                setShowFooter(true);
            }
        };

        // Add the scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Cleanup the event listener when the component unmounts
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleDeleteJantri = () => {
        navigate("/DeleteJantri");
    }
    const updateResult = () => {
        navigate("/UpdateResult");
    }
    const cutPage = () => {
        navigate("/gameCutting");
    }
    const handleJantri = () => {
        navigate("/betHistory");
    }

    const handleClientChange = (e) => {
        console.log("e.targetvalue", e.target.value)
        const value = e.target.value === '' ? null : e.target.value;
        setIsClient(value);
    };

    const handleGameChange = (e) => {
        const value = e.target.value === '' ? null : e.target.value;
        setIsGames(value);
    };

    const handleChangeHrufType = (e) => {
        setHrufType(e.target.value);
    };


    useEffect(() => {
        (async () => {
            if (isClient && isGames) {
                let data = {
                    "client_name": isClient,
                    "game_name": isGames,
                    "username": JSON.parse(localStorage.getItem('userinfo'))?.username,
                    "user_id": JSON.parse(localStorage.getItem('userinfo'))?.userId
                }

                setLoad(true);
                setLoadColor("#ff4364");
                let res = await BetDataJantri(data);
                console.log(res.data);
                if (res) {
                    if (res.data.status) {
                        const sortedData = res.data.updatedBetNumbers.details.sort((a, b) => {
                            const keyA = Object.keys(a)[0];
                            const keyB = Object.keys(b)[0];
                            return parseInt(keyA, 10) - parseInt(keyB, 10);
                        });
                        console.log("sortedData ---> ", sortedData);
                        setNumberData(sortedData);

                        const HarufBetNumbersAndr = res.data.HarufBetNumbers.andar;
                        console.log("highlightedNumbers ---> ", HarufBetNumbersAndr);
                        setHarufAndar(HarufBetNumbersAndr);

                        let HarufBetNumbersBhar = res.data.HarufBetNumbers.bahar;
                        console.log("HarufBetNumbersBhar ---> ", HarufBetNumbersBhar);
                        setHarufBahar(HarufBetNumbersBhar);

                        setWallet(res.data.updatedBetNumbers.total_amount);
                    }
                    else {
                        setNumberData(sessionDetail?.bet_numbers);
                        setHarufAndar([]);
                        setHarufBahar([]);
                        setWallet(0);
                        toast.error(res.data.message, {
                            position: "top-right",
                            autoClose: 1500,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            transition: Flip,
                        });
                    }
                }
                setLoad(false);
            } else {
                setNumberData(sessionDetail?.bet_numbers);
                setHarufAndar([]);
                setHarufBahar([]);
                setWallet(0);
            }
        })();
    }, [isClient, isGames, sessionDetail?.bet_numbers, setLoad, setLoadColor, setWallet]); // <-- Add missing dependencies


    const handleHrufBet = async () => {
        if (isClient && isGames) {
            if (hrufNumber && hrufAmount) {
                let data = {
                    "client_name": isClient,
                    "game_name": isGames,
                    "bet_type": "hruf",
                    "bet_data": {
                        "number": hrufNumber.toString(),
                        "hruf_type": hrufType,
                        "amount": hrufAmount
                    },
                    "username": JSON.parse(localStorage.getItem('userinfo'))?.username,
                    "user_id": JSON.parse(localStorage.getItem('userinfo'))?.userId
                }

                setLoad(true);
                setLoadColor("#ff4364")
                let res = await BetPlace(data);
                console.log(res.data)
                if (res) {
                    if (res.data.status) {
                        clearData();
                        const sortedData = res.data.updatedBetNumbers.details.sort((a, b) => {
                            const keyA = Object.keys(a)[0];
                            const keyB = Object.keys(b)[0];
                            return parseInt(keyA, 10) - parseInt(keyB, 10);
                        });

                        setNumberData(sortedData)

                        const HarufBetNumbersAndr = res.data.HarufBetNumbers.andar;
                        // const highlightedNumbers = HarufBetNumbersAndr.map(obj => Number(Object.keys(obj)[0]));
                        console.log("highlightedNumbers ---> ", HarufBetNumbersAndr);
                        setHarufAndar(HarufBetNumbersAndr);

                        const HarufBetNumbersBhar = res.data.HarufBetNumbers.bahar;
                        // HarufBetNumbersBhar = HarufBetNumbersBhar.map(obj => Number(Object.keys(obj)[0]));
                        console.log("HarufBetNumbersBhar ---> ", HarufBetNumbersBhar);
                        setHarufBahar(HarufBetNumbersBhar);
                        setWallet(res.data.updatedBetNumbers.total_amount);

                    }
                    else {
                        toast.error(res.data.message, {
                            position: "top-right",
                            autoClose: 1500,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            transition: Flip,
                        });
                    }
                }
                setLoad(false);
            } else {
                toast.error("Please select Hruf type Data and field properly", {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } else {
            toast.error("Please select Client and games", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            });
        }
    }

    const handleCrossingBet = async () => {
        if (isClient && isGames) {
            if (crossingJodaCut) {
                if (crossingNumber.length < 2) {
                    toast.error("Please enter 2 digit number", {
                        position: "top-right",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                        transition: Flip,
                    });
                    return;
                }
            }
            if (crossingNumber && crossingAmount) {
                let data = {
                    "client_name": isClient,
                    "game_name": isGames,
                    "bet_type": "crossing",
                    "bet_data": {
                        "number": crossingNumber.toString(),
                        "isJodaCut": crossingJodaCut,
                        "amount": crossingAmount
                    },
                    "username": JSON.parse(localStorage.getItem('userinfo'))?.username,
                    "user_id": JSON.parse(localStorage.getItem('userinfo'))?.userId
                }

                console.log(data, "crossing type");

                setLoad(true);
                setLoadColor("#ff4364")
                let res = await BetPlace(data);
                console.log(res.data)
                if (res) {
                    if (res.data.status) {
                        clearData();
                        const sortedData = res.data.updatedBetNumbers.details.sort((a, b) => {
                            const keyA = Object.keys(a)[0];
                            const keyB = Object.keys(b)[0];
                            return parseInt(keyA, 10) - parseInt(keyB, 10);
                        });
                        setNumberData(sortedData)

                        setWallet(res.data.updatedBetNumbers.total_amount);

                    }
                    else {
                        toast.error(res.data.message, {
                            position: "top-right",
                            autoClose: 1500,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            transition: Flip,
                        });
                    }
                }
                setLoad(false);
            } else {
                toast.error("Please select Hruf type Data and field properly", {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } else {
            toast.error("Please select Client and games", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            });
        }
    }

    const handleBattaCrossingBet = async () => {
        if (isClient && isGames) {
            if (battacrossingNumber1 && battacrossingNumber2 && battacrossingAmount) {
                let data = {
                    "client_name": isClient,
                    "game_name": isGames,
                    "bet_type": "batta_crossing",
                    "bet_data": {
                        "number1": battacrossingNumber1,
                        "number2": battacrossingNumber2,
                        "amount": battacrossingAmount
                    },
                    "username": JSON.parse(localStorage.getItem('userinfo'))?.username,
                    "user_id": JSON.parse(localStorage.getItem('userinfo'))?.userId
                }

                console.log(data, "batta crossing type");

                setLoad(true);
                setLoadColor("#ff4364")
                let res = await BetPlace(data);
                console.log(res.data)
                if (res) {
                    if (res.data.status) {
                        clearData();
                        const sortedData = res.data.updatedBetNumbers.details.sort((a, b) => {
                            const keyA = Object.keys(a)[0];
                            const keyB = Object.keys(b)[0];
                            return parseInt(keyA, 10) - parseInt(keyB, 10);
                        });
                        setNumberData(sortedData)

                        setWallet(res.data.updatedBetNumbers.total_amount);

                    }
                    else {
                        toast.error(res.data.message, {
                            position: "top-right",
                            autoClose: 1500,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            transition: Flip,
                        });
                    }
                }
                setLoad(false);
            } else {
                toast.error("Please select Hruf type Data and field properly", {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } else {
            toast.error("Please select Client and games", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            });
        }
    }

    const handleLadiBet = async () => {
        if (isClient && isGames) {
            if (ladiNumber1 && ladiNumber2 && ladiAmount) {
                let data = {
                    "client_name": isClient,
                    "game_name": isGames,
                    "bet_type": "ladi",
                    "bet_data": {
                        "number1": ladiNumber1,
                        "number2": ladiNumber2,
                        "amount": ladiAmount
                    },
                    "username": JSON.parse(localStorage.getItem('userinfo'))?.username,
                    "user_id": JSON.parse(localStorage.getItem('userinfo'))?.userId
                }

                console.log(data, "Ladi crossing type");

                setLoad(true);
                setLoadColor("#ff4364")
                let res = await BetPlace(data);
                console.log(res.data)
                if (res) {
                    if (res.data.status) {
                        clearData();
                        const sortedData = res.data.updatedBetNumbers.details.sort((a, b) => {
                            const keyA = Object.keys(a)[0];
                            const keyB = Object.keys(b)[0];
                            return parseInt(keyA, 10) - parseInt(keyB, 10);
                        });
                        setNumberData(sortedData)

                        setWallet(res.data.updatedBetNumbers.total_amount);

                    }
                    else {
                        toast.error(res.data.message, {
                            position: "top-right",
                            autoClose: 1500,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            transition: Flip,
                        });
                    }
                }
                setLoad(false);
            } else {
                toast.error("Please select Hruf type Data and field properly", {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } else {
            toast.error("Please select Client and games", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            });
        }
    }

    const handleStringBet = async () => {
        if (isClient && isGames) {
            if (stringData) {
                let data = {
                    "client_name": isClient,
                    "game_name": isGames,
                    "bet_type": "string",
                    "bet_data": {
                        "dataString": stringData,
                        "withPalat": isPalat
                    },
                    "username": JSON.parse(localStorage.getItem('userinfo'))?.username,
                    "user_id": JSON.parse(localStorage.getItem('userinfo'))?.userId
                }

                console.log(data, "Ladi crossing type");

                setLoad(true);
                setLoadColor("#ff4364")
                let res = await BetPlace(data);
                console.log(res.data)
                if (res) {
                    if (res.data.status) {
                        setStringData("")
                        clearData();

                        const sortedData = res.data.updatedBetNumbers.details.sort((a, b) => {
                            const keyA = Object.keys(a)[0];
                            const keyB = Object.keys(b)[0];
                            return parseInt(keyA, 10) - parseInt(keyB, 10);
                        });
                        setNumberData(sortedData)

                        setWallet(res.data.updatedBetNumbers.total_amount);

                    }
                    else {
                        toast.error(res.data.message, {
                            position: "top-right",
                            autoClose: 1500,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            transition: Flip,
                        });
                    }
                }
                setLoad(false);
            } else {
                toast.error("Please select Hruf type Data and field properly", {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } else {
            toast.error("Please select Client and games", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            });
        }
    }


    return (
        <>
            <div className='WholeNumberComponent'>

                <div className='container-Section'>
                    <div className="select-section">
                        <select
                            className="select-dropdown"
                            id="client-select"
                            aria-label="Select Client"
                            onChange={handleClientChange}
                        >
                            <option value=''>Select Client</option>
                            {sessionDetail?.user_clients?.map((client, index) => (
                                <option key={index} value={client}>{client}</option>
                            ))}
                        </select>

                        <select
                            className="select-dropdown"
                            id="game-select"
                            aria-label="Select Game"
                            onChange={handleGameChange}
                        >
                            <option value=''>Select Game</option>
                            {sessionDetail?.user_games?.map((game, index) => (
                                <option key={index} value={game}>{game}</option>
                            ))}
                        </select>
                    </div>
                </div>


                <div className="numbers-grid">
                    {/* {numberData?.map((ele, i) => {
                        let label, value;

                        if (typeof ele === 'object' && ele !== null) {
                            label = Object.keys(ele)[0];
                            value = ele[label];
                        } else {
                            const num = (ele < 10 ? `0${ele}` : `${ele}`);
                            label = num;
                            value = null;
                        }

                        return (
                            <div className="number-item" key={i}>
                                <div className="number-label">{label}</div>
                                <div className="number-box">{(value === null || value === 0) ? "" : value}</div>
                            </div>
                        );
                    })} */}

                    {numberData?.map((ele, i) => {
                        let label, value;
                        console.log("Element --> ", ele);
                        if (typeof ele === 'object' && ele !== null) {
                            label = Object.keys(ele)[0];
                            value = ele[label];

                            // ✅ Convert "100" → "00" for display
                            if (label === "100" || label === 100) {
                                label = "00";
                            }
                            // // Optional: add zero-padding for single digits like "1" → "01"
                            // else if (!isNaN(label) && Number(label) < 10) {
                            //     label = `0${Number(label)}`;
                            // }
                        }
                        else {
                            // ✅ Show "00" instead of "100"
                            if (ele === 100) {
                                label = "00";
                            } else {
                                label = ele < 10 ? `0${ele}` : `${ele}`;
                            }
                            value = null;
                        }

                        return (
                            <div className="number-item" key={i}>
                                <div className="number-label">{label}</div>
                                <div className="number-box">{(value === null || value === 0) ? "" : value}</div>
                            </div>
                        );
                    })}

                </div>

                <div className="color-row">
                    <div className="color-label">A. H.</div>
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((ele, i) => {
                        const highlightedObj = harufAndar.find(obj => obj[ele] !== undefined);
                        const isHighlighted = highlightedObj !== undefined;
                        const value = isHighlighted ? highlightedObj[ele] : '';
                        return (
                            <div className="number-item" key={i}>
                                <div className="number-label">{ele}</div>
                                <div className={`number-box ${isHighlighted ? 'highlighted' : ''}`}>
                                    {value}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="color-row">
                    <div className="color-label">B. H.</div>
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((ele, i) => {
                        const highlightedObj = harufBahar.find(obj => obj[ele] !== undefined);
                        const isHighlighted = highlightedObj !== undefined;
                        const value = isHighlighted ? highlightedObj[ele] : '';
                        return (
                            <div className="number-item" key={i}>
                                <div className="number-label">{ele}</div>
                                <div className={`number-box ${isHighlighted ? 'highlighted' : ''}`}>
                                    {(value === null || value === 0) ? "" : value}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>


            <div className="main-container">
                <div className="input-group">
                    <label htmlFor="hruf-type">Hruf-Type</label>
                    <select id="hruf-type" onChange={handleChangeHrufType}>
                        <option value="andar">A.H.</option>
                        <option value="bahar">B.H.</option>
                        <option value="booth">Booth</option>
                    </select>

                    <label htmlFor="hruf-number" id="haruf_number" style={{ color: "#004085" }}>Number</label>
                    <input
                        type="text"
                        id="hruf-number"
                        value={hrufNumber || ''}
                        onChange={(e) => {
                            const input = e.target.value;
                            if (/^\d*$/.test(input)) {
                                const digits = input.split('');
                                const uniqueDigits = new Set(digits);
                                if (uniqueDigits.size === digits.length) {
                                    setHrufNumber(input);
                                }
                            }
                        }}
                    />

                    <label htmlFor="hruf-amount" style={{ color: "green" }}>Amount</label>
                    <input
                        type="number"
                        id="hruf-amount"
                        value={hrufAmount || ''}
                        onChange={(e) => { setHrufAmount(e.target.value ? +e.target.value : 0) }}
                    />

                    <button className="done-btn" onClick={handleHrufBet}>DONE</button>
                </div>


                <div className="row">
                    <div className="col-md-8">
                        <div className="textarea-container"
                        >
                            <label htmlFor="customTextArea">Enter Details:</label>
                            <textarea
                                id="customTextArea"
                                name="customText"
                                rows={6}
                                className="form-control"
                                value={stringData}
                                onChange={(e) => setStringData(e.target.value)}
                                placeholder={placeholder}
                                onFocus={() =>
                                    setPlaceholder(`Paste your copied text here!
Example:- 01,02,11 (20) 35,76,87(10)
नोट :- राशि हमेशा इस तरह ब्रैकेट में टाइप करें (50)
NOTE :- Amount Always type in Bracket Like This (50).`)
                                }
                            />

                        </div>
                    </div>
                    <div className="col-md-3">
                        <div
                            style={{
                                display: 'flex',
                                gap: '6px',
                                marginBottom: '20px',
                                flexDirection: 'column',
                                alignItems: 'flex-end',
                                justifyContent: 'space-evenly',
                                alignContent: 'stretch',
                                flexWrap: 'nowrap',
                                paddingTop: '10px',
                                marginLeft: '60px'
                            }}
                        >
                            <button className="clear-btn" onClick={() => { setStringData('') }}>CLEAR</button>
                            <div className="checkbox-container">
                                <input
                                    type="checkbox"
                                    id="with-palat"
                                    checked={isPalat}
                                    onChange={(e) => { setIsPalat(e.target.checked) }}
                                />
                                <label htmlFor="with-palat">With Palat</label>
                            </div>
                            <button className="done-btn" onClick={handleStringBet}>DONE</button>
                        </div>
                    </div>
                </div>

                {/* Crossing Section */}
                <div className="crossing-group">
                    <div className="controls-row">
                        <label className="section-title">Crossing</label>

                        <div className="input-column">
                            <label htmlFor="crossing_number" style={{ color: "#212529" }}>Number</label>
                            <input
                                type="text"
                                id="crossing_number"
                                value={crossingNumber || ''}
                                onChange={(e) => { setCrossingNumber(e.target.value || '') }}
                            />
                        </div>

                        <div className="input-column">
                            <label htmlFor="crossing_amount" style={{ color: "green" }}>Amount</label>
                            <input
                                type="text"
                                id="crossing_amount"
                                value={crossingAmount || ''}
                                onChange={(e) => { setCrossingAmount(e.target.value ? +e.target.value : 0) }}
                            />
                        </div>

                        <div className="input-column">
                            <label htmlFor="joda-cut" style={{ color: "#b33300" }}>JodaCut</label>
                            <select
                                id="joda-cut"
                                value={crossingJodaCut.toString()}
                                onChange={(e) => setCrossingJodaCut(e.target.value === "true")}
                            >
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                            </select>
                        </div>

                        <button className="done-btn" onClick={handleCrossingBet}>DONE</button>
                    </div>
                </div>

                {/* Batta Crossing Section */}
                <div className="crossing-group">
                    <div className="controls-row">
                        <label className="section-title">Batta Crossing</label>

                        <div className="input-column">
                            <label htmlFor="batta_number1" style={{ color: "#212529" }}>Number</label>
                            <input
                                type="text"
                                id="batta_number1"
                                value={battacrossingNumber1 || ''}
                                onChange={(e) => { setBattaCrossingNumber1(e.target.value || '') }}
                            />
                        </div>

                        <div className="input-column">
                            <label htmlFor="batta_number2" style={{ color: "#212529" }}>Number</label>
                            <input
                                type="text"
                                id="batta_number2"
                                value={battacrossingNumber2 || ''}
                                onChange={(e) => { setBattaCrossingNumber2(e.target.value || '') }}
                            />
                        </div>

                        <div className="input-column">
                            <label htmlFor="batta_amount" style={{ color: "green" }}>Amount</label>
                            <input
                                type="text"
                                id="batta_amount"
                                value={battacrossingAmount || ''}
                                onChange={(e) => { setBattaCrossingAmount(e.target.value ? +e.target.value : 0) }}
                            />
                        </div>

                        <button className="done-btn" onClick={handleBattaCrossingBet}>DONE</button>
                    </div>
                </div>

                {/* Ladi Section */}
                <div className="crossing-group">
                    <div className="controls-row">
                        <label className="section-title">Ladi</label>

                        <div className="input-column">
                            <label htmlFor="ladi_number1" style={{ color: "#212529" }}>Number</label>
                            <input
                                type="text"
                                id="ladi_number1"
                                value={ladiNumber1 || ''}
                                onChange={(e) => { setLadiNumber1(e.target.value || '') }}
                            />
                        </div>

                        <div className="input-column">
                            <label htmlFor="ladi_number2" style={{ color: "#212529" }}>Number</label>
                            <input
                                type="text"
                                id="ladi_number2"
                                value={ladiNumber2 || ''}
                                onChange={(e) => { setLadiNumber2(e.target.value || '') }}
                            />
                        </div>

                        <div className="input-column">
                            <label htmlFor="ladi_amount" style={{ color: "green" }}>Amount</label>
                            <input
                                type="text"
                                id="ladi_amount"
                                value={ladiAmount || ''}
                                onChange={(e) => { setLadiAmount(e.target.value ? +e.target.value : 0) }}
                            />
                        </div>

                        <button className="done-btn" onClick={handleLadiBet}>DONE</button>
                    </div>
                </div>
            </div>

            {showFooter && (
                <div className="footer">
                    <button className="footer-btn" onClick={handleJantri}>Jantri</button>
                    <button className="footer-btn" onClick={cutPage}>Show & Cut</button>
                    <button className="footer-btn" onClick={updateResult}>Update Result</button>
                    <button className="footer-btn" onClick={handleDeleteJantri}>Delete Jantri</button>
                </div>
            )}

        </>
    );

}
